export const normalizeRoutePath = (pathname) => (
    pathname.endsWith('/') ? pathname : `${pathname}/`
);

export const ROUTES = {
    ROOT: '/',
    ADMIN: "/admin/",
    LOGIN: "/login/",
    AUTH_CALLBACK: "/auth/callback/",
    FORGOT_PASSWORD: "/forgot-password/",
    RESET_PASSWORD: "/reset-password/:uidb64/:token/",
    SUPERADMIN_OVERVIEW: "/superadmin/overview/",
    SUPERADMIN_SECURITY: "/superadmin/security/",
    SUPERADMIN_ASSETS: "/superadmin/assets/",
    SUPERADMIN_NETWORK: "/superadmin/network/",
    SUPERADMIN_ENGAGEMENT: "/superadmin/engagement/",
    SUPERADMIN_ENGAGEMENT_RESELL: "/superadmin/engagement/resell/",
    SUPERADMIN_HELPDESK: "/superadmin/helpdesk/",
    CLIENT_OVERVIEW: "/client/overview/",
    CLIENT_SECURITY: "/client/security/",
    CLIENT_ASSETS: "/client/assets/",
    CLIENT_NETWORK: "/client/network/",
    CLIENT_ENGAGEMENT: "/client/engagement/",
    CLIENT_ENGAGEMENT_RESELL: "/client/engagement/resell/",
    CLIENT_HELPDESK: "/client/helpdesk/",
    CLIENT_DASHBOARD: "/client/dashboard/",
    PROFILE: "/profile/",
};

export const isAuthRoute = (pathname) => {
    const normalized = normalizeRoutePath(pathname);
    if (normalized.startsWith("/reset-password/")) {
        return true;
    }
    return [
        ROUTES.LOGIN,
        ROUTES.AUTH_CALLBACK,
        ROUTES.FORGOT_PASSWORD,
    ].includes(normalized);
};
